import type React from 'react';

import { Breadcrumbs, Separator } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useTagBreadcrumbs } from './hooks/useTagBreadcrumbs';

export const TagBreadcrumbs: React.FC = () => {
	const { translate } = useI18n();
	const {
		data: { ask, displayed, slug, tag },
	} = useTagBreadcrumbs();

	if (!displayed) return null;

	// @change/ds-core-ui Breadcrumbs renders a bare <ol>, so we wrap it in a <nav> with an
	// accessible name to restore the breadcrumb navigation landmark. Remove this wrapper once
	// the DS component provides the landmark itself (CHANGE-94348).
	return (
		<>
			<nav
				aria-label={translate('corgi.petition_gamma.details.tag_breadcrumbs.aria_label')}
				className="[&_ol_li_a:last-child]:text-typography-strong! [&_ol_li_a:last-child]:no-underline! [&_ol_li_a:last-child>span]:no-underline!"
			>
				<Breadcrumbs
					items={[
						{ label: 'Change.org', href: '/' },
						{
							label: translate('corgi.topic_page.breadcrumbs.topic'),
							href: '/topic?source_location=petition_page_breadcrumb',
						},
						{ label: tag?.name || '', href: `/topic/${tag?.slug}?source_location=petition_page_breadcrumb` },
						{ label: ask, href: `/p/${slug}` },
					]}
				/>
			</nav>
			<Separator className="mt-14 mb-2 md:mt-20" />
		</>
	);
};
